import React, { useEffect, useState } from "react";
import "./UnAuthPinpoints.css";
import PinPointsContainer from "../../components/PinPointsContainer/PinPointsContainer";
import GlobalBackground from "../../components/GlobalBackground/GlobalBackground";
import CommonLoginToHeader from "../../components/CommonLoginToHeader/CommonLoginToHeader";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { pinpointStatus } from "../../redux/slices/authSlice";

const UnAuthPinpoints: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const newPinpoint: any = sessionStorage.getItem("unAuthAddress");
  const pinpointDetails = JSON.parse(newPinpoint);

  const pinpoint:any = [pinpointDetails.addresses];
  const userDetails = pinpointDetails;
  useEffect(() => {
    const handlePopState = () => {
      sessionStorage.removeItem("unAuthAddress");
      dispatch(pinpointStatus(true));
      navigate("/");
      window.history.pushState(null, "", window.location.href);
    };

    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  return (
    <GlobalBackground>
      <CommonLoginToHeader
        title={"PinPoint Addresses"}
        screen={"unAuthPinpoints"}
        backScreen={""}
      />

      <h1 className="unauth-pinpoint">My PinPoints</h1>
      <PinPointsContainer pinpoint={pinpoint} userDetails={userDetails} />

      <div
        onClick={() => {
          navigate("/register");
          sessionStorage.removeItem("unAuthAddress");
        }}
        className="unauth-button"
      >
        <button type="submit">Add New PinPoint</button>
      </div>
    </GlobalBackground>
  );
};

export default UnAuthPinpoints;
